import { render } from "./ObjectsOverview.vue?vue&type=template&id=270c2d0a&scoped=true"
import script from "./ObjectsOverview.vue?vue&type=script&lang=js"
export * from "./ObjectsOverview.vue?vue&type=script&lang=js"

import "./ObjectsOverview.vue?vue&type=style&index=0&id=270c2d0a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270c2d0a"]])

export default __exports__